import { useReceivedPaymentDetailContext } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/context/ReceivedPaymentDetailContext"

export const useReceivedPaymentDetailBodyGeneralInfo = () => {
    const { chargeInstanceDetailData } = useReceivedPaymentDetailContext()
    return {
        chargeInstanceDetailData
    }
}